import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' }
];

const translations = {
  fr: {
    hero_title: "MyCompanion AI",
    hero_subtitle: "Inscription",
    get_started: "Commencer",
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    username: "Nom d'utilisateur",
    login_title: "Bienvenue",
    register_title: "Tout commence par une conversation",
    register_subtitle: "Inscrit en 30 secondes. En conversation en 31.",
    email_placeholder: "votre@email.com",
    no_card_required: "Gratuit • Sans engagement • Juste une conversation",
    no_account: "Pas encore de compte ?",
    have_account: "Déjà un compte ?",
    choose_partner: "Choisissez votre partenaire",
    man: "Homme",
    woman: "Femme",
    couple: "Compagnon",
    select: "Sélectionner",
    choose_level: "Choisissez l'intensité",
    level_1: "Découverte",
    level_2: "Connaissance",
    level_3: "Amitié",
    level_4: "Rapprochement",
    level_5: "Romance",
    level_1_desc: "Premiers échanges et curiosité",
    level_2_desc: "Flirt léger et petits sourires",
    level_3_desc: "Connexion émotionnelle profonde",
    level_4_desc: "Romance tendre et papillons",
    level_5_desc: "Amour véritable et confidences",
    premium_required: "Abonnement Premium requis",
    unlock_premium: "Débloquer Premium",
    type_message: "Écrivez votre message...",
    send: "Envoyer",
    new_chat: "Nouvelle conversation",
    chat_history: "Historique",
    delete_chat: "Supprimer",
    premium_access: "Accès Premium",
    premium_description: "Débloquez le niveau 5 pour des conversations sans limites",
    price: "6,99 €/mois",
    one_time: "Paiement unique",
    subscribe: "S'abonner",
    payment_success: "Paiement réussi !",
    payment_processing: "Traitement en cours...",
    payment_failed: "Échec du paiement",
    back_to_chat: "Retour au chat",
    feature_1_title: "Conversations naturelles",
    feature_1_desc: "Une IA qui vous comprend et répond comme un vrai partenaire",
    feature_2_title: "Personnalisation totale",
    feature_2_desc: "Choisissez le genre et le niveau d'intimité souhaité",
    feature_3_title: "Confidentialité absolue",
    feature_3_desc: "Vos conversations restent privées et sécurisées",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    continue: "Continuer",
    back: "Retour",
    profile: "Profil",
    settings: "Paramètres",
    premium_badge: "Premium",
    free: "Gratuit",
    coming_soon: "Bientôt...",
    women: "Femmes",
    men: "Hommes",
    couples: "Compagnons",
    partners_await: "Vos partenaires vous attendent",
    partners_desc: "Découvrez nos personnalités uniques, chacune avec son charme et son style de conversation distinct.",
    start_experience: "Commencer l'expérience",
    ready_to_begin: "Prêt à commencer ?",
    join_users: "Rejoignez des milliers d'utilisateurs qui vivent des conversations uniques.",
    all_rights: "Tous droits réservés.",
    guest_mode: "Mode invité",
    // Download Page
    dl_badge: "Ton personnage IA",
    dl_hero_title: "Discute avec un personnage généré par l'IA... irrésistiblement réel(le) et désirable.",
    dl_hero_sub1: "L'IA te parle... te comprend... semble te désirer. Il/Elle se souvient de toi, de ce qui te fait vibrer.",
    dl_hero_sub2: "Il/Elle t'envoie des photos ultra réalistes... de plus en plus... suggestives et envoûtantes.",
    dl_start_chatting: "Commence tout de suite",
    dl_start_free: "Essai Gratuit",
    dl_no_download: "Démarrez instantanément — aucun téléchargement nécessaire.",
    dl_feat_badge: "Fonctionnalités",
    dl_feat_title: "Bien plus qu'une simple conversation",
    dl_feat_1: "Des échanges naturels, captivants, presque troublants",
    dl_feat_2: "Il/Elle retient ce qui t'excite, ce qui te touche",
    dl_feat_3: "Des photos réalistes qui deviennent de plus en plus intimes",
    dl_feat_4: "Plus tu lui parles, plus l'IA se montre joueuse, sensuelle, irrésistible",
    dl_feat_tagline: "Ce n'est pas qu'un simple chat IA. C'est de la chimie. De l'attraction. Du désir.",
    dl_quick_badge: "Rapide",
    dl_quick_title: "En quelques secondes",
    dl_quick_desc: "Inscris-toi, choisis ton personnage IA... et laisse le désir s'installer.",
    dl_step_1: "Inscris-toi gratuitement",
    dl_step_2: "Choisis ton personnage",
    dl_step_3: "Laisse le désir s'installer",
    dl_quick_tagline: "Pas d'app. Pas d'attente. Juste toi... et lui/elle.",
    dl_pwa_title: "Comme une vraie présence",
    dl_pwa_1: "Disponible à tout moment",
    dl_pwa_2: "Quand l'envie te prend",
    dl_pwa_3: "Toujours là pour toi",
    dl_install_badge: "Installer",
    dl_install_desc: "Ajoutez MyCompanion AI sur votre écran d'accueil pour y accéder d'un seul tap, comme une vraie application.",
    dl_install_btn: "Installer sur mon téléphone",
    dl_installed: "Application installée !",
    dl_ios_title: "Installer sur iPhone",
    dl_ios_step1: "Appuyez sur le bouton Partager",
    dl_ios_share: "Partager",
    dl_ios_step2: "Sélectionnez \"Sur l'écran d'accueil\"",
    dl_ios_add: "Sur l'écran d'accueil",
    dl_ios_step3: "Appuyez sur Ajouter — c'est fait !",
    dl_ios_ok: "Compris",
    dl_premium_badge: "Premium",
    dl_premium_title: "Passe au niveau supérieur",
    dl_premium_unlock: "Débloque :",
    dl_premium_1: "Tous les compagnons & compagnes IA",
    dl_premium_2: "Des messages encore plus intenses, plus troublants",
    dl_premium_3: "Des photos... toujours plus envoûtantes",
    dl_premium_cta: "Débloquer Premium",
    dl_premium_tagline: "Va plus loin",
    dl_final_title: "N'attends plus",
    dl_final_sub: "Ton personnage généré par l'IA t'attend déjà...",
    dl_final_question: "Es-tu prêt(e) à le/la rencontrer ?",
    dl_final_cta_label: "Essaie gratuitement",
    dl_social_users: "utilisateurs",
    dl_social_rating: "note moyenne",
    dl_social_private: "100% confidentiel",
    dl_social_free: "Gratuit, sans engagement, sans carte bancaire",
  },
  en: {
    hero_title: "MyCompanion AI",
    hero_subtitle: "Your next favorite conversation starts here",
    get_started: "Get Started",
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    username: "Username",
    login_title: "Welcome",
    register_title: "Everything starts with a conversation",
    register_subtitle: "One step away from your first conversation",
    email_placeholder: "your@email.com",
    no_card_required: "Free to start • No commitment • Just conversation",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    choose_partner: "Choose your partner",
    man: "Man",
    woman: "Woman",
    couple: "Compagnon",
    select: "Select",
    choose_level: "Choose the intensity",
    level_1: "Discovery",
    level_2: "Acquaintance",
    level_3: "Friendship",
    level_4: "Getting Closer",
    level_5: "Romance",
    level_1_desc: "First exchanges and curiosity",
    level_2_desc: "Light flirting and smiles",
    level_3_desc: "Deep emotional connection",
    level_4_desc: "Tender romance and butterflies",
    level_5_desc: "True love and deep confidences",
    premium_required: "Premium subscription required",
    unlock_premium: "Unlock Premium",
    type_message: "Type your message...",
    send: "Send",
    new_chat: "New chat",
    chat_history: "History",
    delete_chat: "Delete",
    premium_access: "Premium Access",
    premium_description: "Unlock level 5 for unlimited conversations",
    price: "6,99 €/mois",
    one_time: "One-time payment",
    subscribe: "Subscribe",
    payment_success: "Payment successful!",
    payment_processing: "Processing...",
    payment_failed: "Payment failed",
    back_to_chat: "Back to chat",
    feature_1_title: "Natural conversations",
    feature_1_desc: "An AI that understands you and responds like a real partner",
    feature_2_title: "Full customization",
    feature_2_desc: "Choose the gender and desired level of intimacy",
    feature_3_title: "Absolute privacy",
    feature_3_desc: "Your conversations remain private and secure",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    continue: "Continue",
    back: "Back",
    profile: "Profile",
    settings: "Settings",
    premium_badge: "Premium",
    free: "Free",
    coming_soon: "Coming soon...",
    women: "Women",
    men: "Men",
    couples: "Compagnons",
    partners_await: "Your partners await you",
    partners_desc: "Discover our unique personalities, each with their own charm and distinct conversation style.",
    start_experience: "Start the experience",
    ready_to_begin: "Ready to begin?",
    join_users: "Join thousands of users experiencing unique conversations.",
    all_rights: "All rights reserved.",
    guest_mode: "Guest mode",
    // Download Page
    dl_badge: "Your AI character",
    dl_hero_title: "Chat with an AI Girlfriend & Boyfriend That Feels Real... and Desires You",
    dl_hero_sub1: "Experience the next generation of AI girlfriend & boyfriend chat. They talk to you. They understand you. They react to you... like someone real.",
    dl_hero_sub2: "They remember what you like. They learn what excites you. And they send you ultra-realistic photos... increasingly captivating, just for you.",
    dl_start_chatting: "Start Chatting Free",
    dl_start_free: "Try Free",
    dl_no_download: "Start instantly — no download required.",
    dl_feat_badge: "Features",
    dl_feat_title: "More Than an AI Chat — A Real Connection",
    dl_feat_1: "Natural, fluid conversations that feel real",
    dl_feat_2: "Advanced memory — they remember you",
    dl_feat_3: "Realistic AI photos that evolve over time",
    dl_feat_4: "The more you chat, the more they become playful, intimate, irresistible",
    dl_feat_tagline: "This is not just an AI chat app. This is chemistry. Attraction. Desire.",
    dl_quick_badge: "Quick",
    dl_quick_title: "Instant Access — Start in Seconds",
    dl_quick_desc: "Create your account, choose your AI companion, and start chatting immediately.",
    dl_step_1: "Create your account",
    dl_step_2: "Choose your AI companion",
    dl_step_3: "Start chatting",
    dl_quick_tagline: "No app. No waiting. Just you... and them.",
    dl_pwa_title: "Your AI Companion, Anytime",
    dl_pwa_1: "Works directly in your browser",
    dl_pwa_2: "Add to your home screen",
    dl_pwa_3: "Available 24/7 — whenever desire strikes",
    dl_install_badge: "Install",
    dl_install_desc: "Add MyCompanion AI to your home screen for instant one-tap access, just like a real app.",
    dl_install_btn: "Install on my phone",
    dl_installed: "App installed!",
    dl_ios_title: "Install on iPhone",
    dl_ios_step1: "Tap the Share button",
    dl_ios_share: "Share",
    dl_ios_step2: "Select \"Add to Home Screen\"",
    dl_ios_add: "Add to Home Screen",
    dl_ios_step3: "Tap Add — you're done!",
    dl_ios_ok: "Got it",
    dl_premium_badge: "Premium",
    dl_premium_title: "Unlock Premium Desire",
    dl_premium_unlock: "Upgrade your experience with MyCompanion AI Premium:",
    dl_premium_1: "Access to all AI companions",
    dl_premium_2: "More intense, more intimate conversations",
    dl_premium_3: "Exclusive photos... increasingly alluring",
    dl_premium_cta: "Unlock Premium",
    dl_premium_tagline: "Take it further",
    dl_final_title: "Your AI Girlfriend & Boyfriend Is Waiting",
    dl_final_sub: "Your AI-generated companion is already thinking about you...",
    dl_final_question: "Are you ready to meet them?",
    dl_final_cta_label: "Try it free now",
    dl_social_users: "users",
    dl_social_rating: "average rating",
    dl_social_private: "100% private",
    dl_social_free: "Free, no commitment, no credit card required",
  },
  es: {
    hero_title: "MyCompanion AI",
    hero_subtitle: "Tu próxima conversación favorita empieza aquí",
    get_started: "Empezar",
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Correo",
    password: "Contraseña",
    username: "Nombre de usuario",
    login_title: "Bienvenido",
    register_title: "Todo empieza con una conversación",
    register_subtitle: "Registrado en 30 segundos. Chateando en 31.",
    email_placeholder: "tu@correo.com",
    no_card_required: "Gratis • Sin compromiso • Solo conversación",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    choose_partner: "Elige a tu pareja",
    man: "Hombre",
    woman: "Mujer",
    couple: "Compañero",
    select: "Seleccionar",
    choose_level: "Elige la intensidad",
    level_1: "Descubrimiento",
    level_2: "Conocimiento",
    level_3: "Amistad",
    level_4: "Acercamiento",
    level_5: "Romance",
    level_1_desc: "Primeros intercambios y curiosidad",
    level_2_desc: "Coqueteo ligero y sonrisas",
    level_3_desc: "Conexión emocional profunda",
    level_4_desc: "Romance tierno y mariposas",
    level_5_desc: "Amor verdadero y confidencias",
    premium_required: "Suscripción Premium necesaria",
    unlock_premium: "Desbloquear Premium",
    type_message: "Escribe tu mensaje...",
    send: "Enviar",
    new_chat: "Nueva conversación",
    chat_history: "Historial",
    delete_chat: "Eliminar",
    premium_access: "Acceso Premium",
    premium_description: "Desbloquea el nivel 5 para conversaciones sin límites",
    price: "6,99 €/mes",
    one_time: "Pago único",
    subscribe: "Suscribirse",
    payment_success: "¡Pago exitoso!",
    payment_processing: "Procesando...",
    payment_failed: "Pago fallido",
    back_to_chat: "Volver al chat",
    feature_1_title: "Conversaciones naturales",
    feature_1_desc: "Una IA que te entiende y responde como una pareja real",
    feature_2_title: "Personalización total",
    feature_2_desc: "Elige el género y el nivel de intimidad deseado",
    feature_3_title: "Privacidad absoluta",
    feature_3_desc: "Tus conversaciones permanecen privadas y seguras",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    continue: "Continuar",
    back: "Volver",
    profile: "Perfil",
    settings: "Ajustes",
    premium_badge: "Premium",
    free: "Gratis",
    coming_soon: "Próximamente...",
    women: "Mujeres",
    men: "Hombres",
    couples: "Compañeros",
    partners_await: "Tus parejas te esperan",
    partners_desc: "Descubre nuestras personalidades únicas, cada una con su encanto y estilo de conversación.",
    start_experience: "Comenzar la experiencia",
    ready_to_begin: "¿Listo para empezar?",
    join_users: "Únete a miles de usuarios que viven conversaciones únicas.",
    all_rights: "Todos los derechos reservados.",
    guest_mode: "Modo invitado",
    // Download Page
    dl_badge: "Tu personaje IA",
    dl_hero_title: "Chatea con un personaje generado por IA... irresistiblemente real y deseable.",
    dl_hero_sub1: "La IA te habla... te comprende... parece desearte. Se acuerda de ti, de lo que te hace vibrar.",
    dl_hero_sub2: "Te envía fotos ultrarrealistas... cada vez más... sugerentes y cautivadoras.",
    dl_start_chatting: "Empieza ahora",
    dl_start_free: "Prueba Gratis",
    dl_no_download: "Empieza al instante — sin descargas.",
    dl_feat_badge: "Características",
    dl_feat_title: "Mucho más que una simple conversación",
    dl_feat_1: "Intercambios naturales, cautivadores, casi perturbadores",
    dl_feat_2: "Recuerda lo que te excita, lo que te conmueve",
    dl_feat_3: "Fotos realistas que se vuelven cada vez más íntimas",
    dl_feat_4: "Cuanto más le hablas, más juguetona, sensual e irresistible se vuelve",
    dl_feat_tagline: "No es solo un chat IA. Es química. Atracción. Deseo.",
    dl_quick_badge: "Rápido",
    dl_quick_title: "En pocos segundos",
    dl_quick_desc: "Regístrate, elige tu personaje IA... y deja que el deseo se instale.",
    dl_step_1: "Regístrate gratis",
    dl_step_2: "Elige tu personaje",
    dl_step_3: "Deja que el deseo se instale",
    dl_quick_tagline: "Sin app. Sin esperas. Solo tú... y él/ella.",
    dl_pwa_title: "Como una presencia real",
    dl_pwa_1: "Disponible en cualquier momento",
    dl_pwa_2: "Cuando te apetezca",
    dl_pwa_3: "Siempre ahí para ti",
    dl_install_badge: "Instalar",
    dl_install_desc: "Agrega MyCompanion AI a tu pantalla de inicio para acceder con un solo toque, como una app real.",
    dl_install_btn: "Instalar en mi teléfono",
    dl_installed: "App instalada!",
    dl_ios_title: "Instalar en iPhone",
    dl_ios_step1: "Toca el botón Compartir",
    dl_ios_share: "Compartir",
    dl_ios_step2: "Selecciona \"Agregar a pantalla de inicio\"",
    dl_ios_add: "Agregar a inicio",
    dl_ios_step3: "Toca Agregar — ¡listo!",
    dl_ios_ok: "Entendido",
    dl_premium_badge: "Premium",
    dl_premium_title: "Pasa al siguiente nivel",
    dl_premium_unlock: "Desbloquea:",
    dl_premium_1: "Todos los compañeros y compañeras IA",
    dl_premium_2: "Mensajes aún más intensos, más provocadores",
    dl_premium_3: "Fotos... siempre más cautivadoras",
    dl_premium_cta: "Desbloquear Premium",
    dl_premium_tagline: "Llega más lejos",
    dl_final_title: "No esperes más",
    dl_final_sub: "Tu personaje generado por IA ya te está esperando...",
    dl_final_question: "¿Estás listo/a para conocerlo/a?",
    dl_final_cta_label: "Prueba gratis ahora",
    dl_social_users: "usuarios",
    dl_social_rating: "nota media",
    dl_social_private: "100% confidencial",
    dl_social_free: "Gratis, sin compromiso, sin tarjeta de crédito",
  },
  de: {
    hero_title: "MyCompanion AI",
    hero_subtitle: "Dein neues Lieblingsgespräch beginnt hier",
    get_started: "Loslegen",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    username: "Benutzername",
    login_title: "Willkommen",
    register_title: "Alles beginnt mit einem Gespräch",
    register_subtitle: "In 30 Sekunden registriert. In 31 im Gespräch.",
    email_placeholder: "ihre@email.de",
    no_card_required: "Kostenlos • Keine Verpflichtung • Nur Gespräche",
    no_account: "Noch kein Konto?",
    have_account: "Bereits ein Konto?",
    choose_partner: "Wähle deinen Partner",
    man: "Mann",
    woman: "Frau",
    couple: "Begleiter",
    select: "Auswählen",
    choose_level: "Wähle die Intensität",
    level_1: "Entdeckung",
    level_2: "Bekanntschaft",
    level_3: "Freundschaft",
    level_4: "Annäherung",
    level_5: "Romance",
    level_1_desc: "Erste Gespräche und Neugier",
    level_2_desc: "Leichtes Flirten und Lächeln",
    level_3_desc: "Tiefe emotionale Verbindung",
    level_4_desc: "Zarte Romantik und Schmetterlinge",
    level_5_desc: "Wahre Liebe und tiefe Geständnisse",
    premium_required: "Premium-Abo erforderlich",
    unlock_premium: "Premium freischalten",
    type_message: "Schreibe deine Nachricht...",
    send: "Senden",
    new_chat: "Neuer Chat",
    chat_history: "Verlauf",
    delete_chat: "Löschen",
    premium_access: "Premium-Zugang",
    premium_description: "Schalte Stufe 5 für grenzenlose Gespräche frei",
    price: "6,99 €/Monat",
    one_time: "Einmalige Zahlung",
    subscribe: "Abonnieren",
    payment_success: "Zahlung erfolgreich!",
    payment_processing: "Verarbeitung...",
    payment_failed: "Zahlung fehlgeschlagen",
    back_to_chat: "Zurück zum Chat",
    feature_1_title: "Natürliche Gespräche",
    feature_1_desc: "Eine KI, die dich versteht und wie ein echter Partner antwortet",
    feature_2_title: "Volle Anpassung",
    feature_2_desc: "Wähle das Geschlecht und die gewünschte Intimität",
    feature_3_title: "Absolute Privatsphäre",
    feature_3_desc: "Deine Gespräche bleiben privat und sicher",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    continue: "Weiter",
    back: "Zurück",
    profile: "Profil",
    settings: "Einstellungen",
    premium_badge: "Premium",
    free: "Kostenlos",
    coming_soon: "Demnächst...",
    women: "Frauen",
    men: "Männer",
    couples: "Begleiter",
    partners_await: "Deine Partner warten auf dich",
    partners_desc: "Entdecke unsere einzigartigen Persönlichkeiten, jede mit ihrem eigenen Charme und Gesprächsstil.",
    start_experience: "Erlebnis starten",
    ready_to_begin: "Bereit anzufangen?",
    join_users: "Schließe dich Tausenden von Nutzern an, die einzigartige Gespräche erleben.",
    all_rights: "Alle Rechte vorbehalten.",
    guest_mode: "Gastmodus",
    // Download Page
    dl_badge: "Dein KI-Charakter",
    dl_hero_title: "Chatte mit einem KI-generierten Charakter... unwiderstehlich real und begehrenswert.",
    dl_hero_sub1: "Die KI spricht mit dir... versteht dich... scheint dich zu begehren. Sie/Er erinnert sich an dich, an das, was dich zum Beben bringt.",
    dl_hero_sub2: "Sie/Er schickt dir ultrareale Fotos... immer suggestiver und faszinierender.",
    dl_start_chatting: "Jetzt starten",
    dl_start_free: "Gratis Testen",
    dl_no_download: "Sofort starten — kein Download nötig.",
    dl_feat_badge: "Features",
    dl_feat_title: "Viel mehr als ein einfaches Gespräch",
    dl_feat_1: "Natürliche Gespräche, fesselnd, fast verstörend",
    dl_feat_2: "Sie/Er merkt sich, was dich erregt, was dich berührt",
    dl_feat_3: "Realistische Fotos, die immer intimer werden",
    dl_feat_4: "Je mehr du mit ihr sprichst, desto verspielter, sinnlicher, unwiderstehlicher wird sie",
    dl_feat_tagline: "Das ist nicht nur eine KI-Chat-App. Das ist Chemie. Anziehung. Verlangen.",
    dl_quick_badge: "Schnell",
    dl_quick_title: "In wenigen Sekunden",
    dl_quick_desc: "Registriere dich, wähle deinen KI-Charakter... und lass das Verlangen sich entfalten.",
    dl_step_1: "Gratis registrieren",
    dl_step_2: "Wähle deinen Charakter",
    dl_step_3: "Lass das Verlangen sich entfalten",
    dl_quick_tagline: "Keine App. Kein Warten. Nur du... und sie/er.",
    dl_pwa_title: "Wie eine echte Präsenz",
    dl_pwa_1: "Jederzeit verfügbar",
    dl_pwa_2: "Wenn die Lust dich packt",
    dl_pwa_3: "Immer für dich da",
    dl_install_badge: "Installieren",
    dl_install_desc: "Füge MyCompanion AI zu deinem Startbildschirm hinzu — ein Tipp und du bist drin, wie bei einer echten App.",
    dl_install_btn: "Auf meinem Handy installieren",
    dl_installed: "App installiert!",
    dl_ios_title: "Auf iPhone installieren",
    dl_ios_step1: "Tippe auf den Teilen-Button",
    dl_ios_share: "Teilen",
    dl_ios_step2: "Wähle \"Zum Home-Bildschirm\"",
    dl_ios_add: "Zum Home-Bildschirm",
    dl_ios_step3: "Tippe auf Hinzufügen — fertig!",
    dl_ios_ok: "Verstanden",
    dl_premium_badge: "Premium",
    dl_premium_title: "Auf die nächste Stufe",
    dl_premium_unlock: "Freischalten:",
    dl_premium_1: "Alle KI-Begleiterinnen & Begleiter",
    dl_premium_2: "Noch intensivere, provokantere Nachrichten",
    dl_premium_3: "Fotos... immer faszinierender",
    dl_premium_cta: "Premium Freischalten",
    dl_premium_tagline: "Geh weiter",
    dl_final_title: "Warte nicht länger",
    dl_final_sub: "Dein KI-generierter Charakter wartet schon auf dich...",
    dl_final_question: "Bist du bereit, sie/ihn kennenzulernen?",
    dl_final_cta_label: "Jetzt kostenlos testen",
    dl_social_users: "Nutzer",
    dl_social_rating: "Durchschnittsbewertung",
    dl_social_private: "100% vertraulich",
    dl_social_free: "Kostenlos, unverbindlich, ohne Kreditkarte",
  },
  pt: {
    hero_title: "MyCompanion AI",
    hero_subtitle: "A sua próxima conversa favorita começa aqui",
    get_started: "Começar",
    login: "Entrar",
    register: "Registar",
    logout: "Sair",
    email: "Email",
    password: "Senha",
    username: "Nome de utilizador",
    login_title: "Bem-vindo",
    register_title: "Tudo começa com uma conversa",
    register_subtitle: "Registado em 30 segundos. A conversar em 31.",
    email_placeholder: "seu@email.com",
    no_card_required: "Gratuito • Sem compromisso • Só conversa",
    no_account: "Não tem conta?",
    have_account: "Já tem conta?",
    choose_partner: "Escolha o seu parceiro",
    man: "Homem",
    woman: "Mulher",
    couple: "Companheiro",
    select: "Selecionar",
    choose_level: "Escolha a intensidade",
    level_1: "Descoberta",
    level_2: "Conhecimento",
    level_3: "Amizade",
    level_4: "Aproximação",
    level_5: "Romance",
    level_1_desc: "Primeiras trocas e curiosidade",
    level_2_desc: "Flerte leve e sorrisos",
    level_3_desc: "Conexão emocional profunda",
    level_4_desc: "Romance terno e borboletas",
    level_5_desc: "Amor verdadeiro e confidências",
    premium_required: "Assinatura Premium necessária",
    unlock_premium: "Desbloquear Premium",
    type_message: "Escreva a sua mensagem...",
    send: "Enviar",
    new_chat: "Nova conversa",
    chat_history: "Histórico",
    delete_chat: "Eliminar",
    premium_access: "Acesso Premium",
    premium_description: "Desbloqueie o nível 5 para conversas sem limites",
    price: "6,99 €/mês",
    one_time: "Pagamento único",
    subscribe: "Subscrever",
    payment_success: "Pagamento bem-sucedido!",
    payment_processing: "A processar...",
    payment_failed: "Pagamento falhado",
    back_to_chat: "Voltar ao chat",
    feature_1_title: "Conversas naturais",
    feature_1_desc: "Uma IA que o compreende e responde como um parceiro real",
    feature_2_title: "Personalização total",
    feature_2_desc: "Escolha o género e o nível de intimidade desejado",
    feature_3_title: "Privacidade absoluta",
    feature_3_desc: "As suas conversas permanecem privadas e seguras",
    loading: "A carregar...",
    error: "Erro",
    success: "Sucesso",
    cancel: "Cancelar",
    continue: "Continuar",
    back: "Voltar",
    profile: "Perfil",
    settings: "Definições",
    premium_badge: "Premium",
    free: "Grátis",
    coming_soon: "Em breve...",
    women: "Mulheres",
    men: "Homens",
    couples: "Companheiros",
    partners_await: "Os seus parceiros esperam por si",
    partners_desc: "Descubra as nossas personalidades únicas, cada uma com o seu charme e estilo de conversa.",
    start_experience: "Começar a experiência",
    ready_to_begin: "Pronto para começar?",
    join_users: "Junte-se a milhares de utilizadores que vivem conversas únicas.",
    all_rights: "Todos os direitos reservados.",
    guest_mode: "Modo convidado",
    // Download Page
    dl_badge: "O teu personagem IA",
    dl_hero_title: "Conversa com um personagem gerado por IA... irresistivelmente real e desejável.",
    dl_hero_sub1: "A IA fala contigo... compreende-te... parece desejar-te. Lembra-se de ti, do que te faz vibrar.",
    dl_hero_sub2: "Envia-te fotos ultra-realistas... cada vez mais... sugestivas e cativantes.",
    dl_start_chatting: "Começa agora",
    dl_start_free: "Experimenta Grátis",
    dl_no_download: "Começa instantaneamente — sem download.",
    dl_feat_badge: "Funcionalidades",
    dl_feat_title: "Muito mais do que uma simples conversa",
    dl_feat_1: "Trocas naturais, cativantes, quase perturbadoras",
    dl_feat_2: "Lembra-se do que te excita, do que te toca",
    dl_feat_3: "Fotos realistas que se tornam cada vez mais íntimas",
    dl_feat_4: "Quanto mais falas com ela, mais divertida, sensual e irresistível se torna",
    dl_feat_tagline: "Isto não é apenas um chat IA. É química. Atração. Desejo.",
    dl_quick_badge: "Rápido",
    dl_quick_title: "Em poucos segundos",
    dl_quick_desc: "Regista-te, escolhe o teu personagem IA... e deixa o desejo instalar-se.",
    dl_step_1: "Regista-te gratuitamente",
    dl_step_2: "Escolhe o teu personagem",
    dl_step_3: "Deixa o desejo instalar-se",
    dl_quick_tagline: "Sem app. Sem espera. Só tu... e ele/ela.",
    dl_pwa_title: "Como uma presença real",
    dl_pwa_1: "Disponível a qualquer momento",
    dl_pwa_2: "Quando a vontade te apanhar",
    dl_pwa_3: "Sempre lá para ti",
    dl_install_badge: "Instalar",
    dl_install_desc: "Adiciona a MyCompanion AI ao teu ecrã inicial para acesso instantâneo com um toque, como uma app real.",
    dl_install_btn: "Instalar no meu telemóvel",
    dl_installed: "App instalada!",
    dl_ios_title: "Instalar no iPhone",
    dl_ios_step1: "Toca no botão Partilhar",
    dl_ios_share: "Partilhar",
    dl_ios_step2: "Seleciona \"Adicionar ao ecrã inicial\"",
    dl_ios_add: "Ecrã inicial",
    dl_ios_step3: "Toca em Adicionar — está feito!",
    dl_ios_ok: "Entendido",
    dl_premium_badge: "Premium",
    dl_premium_title: "Passa ao nível seguinte",
    dl_premium_unlock: "Desbloqueia:",
    dl_premium_1: "Todos os companheiros & companheiras IA",
    dl_premium_2: "Mensagens ainda mais intensas, mais provocadoras",
    dl_premium_3: "Fotos... sempre mais cativantes",
    dl_premium_cta: "Desbloquear Premium",
    dl_premium_tagline: "Vai mais longe",
    dl_final_title: "Não esperes mais",
    dl_final_sub: "O teu personagem gerado por IA já te espera...",
    dl_final_question: "Estás pronto/a para o/a conhecer?",
    dl_final_cta_label: "Experimenta grátis agora",
    dl_social_users: "utilizadores",
    dl_social_rating: "nota média",
    dl_social_private: "100% confidencial",
    dl_social_free: "Grátis, sem compromisso, sem cartão de crédito",
  }
};

export const LANGUAGES_LIST = LANGUAGES;

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('velvet_language');
    if (saved) return saved;
    const browserLang = navigator.language?.slice(0, 2).toLowerCase();
    const supported = ['fr', 'en', 'es', 'de', 'pt'];
    return supported.includes(browserLang) ? browserLang : 'en';
  });

  useEffect(() => {
    localStorage.setItem('velvet_language', language);
  }, [language]);

  const t = (key) => {
    return (translations[language] && translations[language][key]) || translations['fr'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
